import { Outlet, Navigate, useParams, useSearchParams } from 'react-router-dom'
import { UUID } from 'uuidjs'
import React, { useEffect, useState } from 'react'
import { Spin } from 'antd'
import { useIntl } from 'react-intl'
import http from '../utils/http'
import { AI_URL } from '../utils/url'
import InterviewLinkError from '../components/InterviewLinkError'
export const NavigatePage = () => {
  const intl = useIntl()
  let params = useParams()
  let [searchParams, setSearchParams] = useSearchParams()
  console.log('searchParams', searchParams)
  let id = searchParams.get('id')
  let state = searchParams.get('state')
  let jdParams = searchParams.get('jdParams')
  let chikkaType = searchParams.get('chikkaType')
  //区分是那种招募方式 =chikka是我们公司帮着招募
  let sourceType = searchParams.get('sourceType')
  const chikkaUserId = searchParams.get('chikka_user_id')
  const chikkaProjectId = searchParams.get('chikka_project_id')
  const preInterviewForm = searchParams.get('pre_interview_form')
  const respondentCode = searchParams.get('chikka_respondent_code')
  const [anonymousSessionId] = useState(() => UUID.generate())
  const [contactSession, setContactSession] = useState(null)
  useEffect(() => {
    if (respondentCode === null) return
    let cancelled = false
    http.post(`${AI_URL}/api/interview/contact-session`, {
      access_code: params.accessId,
      chikka_respondent_code: respondentCode,
    }).then((res) => {
      if (cancelled) return
      setContactSession({
        accessId: params.accessId,
        code: respondentCode,
        sessionId: res.code === 0 ? res.data?.session_id : null,
        error: res.code === 4003 ? 'interviewLinkInvalid' : 'interviewLoadFailed',
        retryable: res.code !== 4003,
      })
    }).catch(() => {
      if (!cancelled) setContactSession({
        accessId: params.accessId, code: respondentCode,
        error: 'interviewLoadFailed', retryable: true,
      })
    })
    return () => { cancelled = true }
  }, [params.accessId, respondentCode])

  if (respondentCode !== null) {
    if (!contactSession || contactSession.accessId !== params.accessId || contactSession.code !== respondentCode) {
      return <Spin fullscreen tip={intl.formatMessage({ id: 'interviewLoading' })} />
    }
    if (!contactSession.sessionId) {
      return <InterviewLinkError messageId={contactSession.error} retryable={contactSession.retryable} />
    }
  }
  const sessionId = respondentCode !== null ? contactSession.sessionId : anonymousSessionId

  const appendChikkaParams = (url) => {
    const chikkaParams = new URLSearchParams()
    if (respondentCode !== null) {
      chikkaParams.set('chikka_respondent_code', respondentCode)
    }
    if (chikkaUserId) {
      chikkaParams.set('chikka_user_id', chikkaUserId)
    }
    if (chikkaProjectId) {
      chikkaParams.set('chikka_project_id', chikkaProjectId)
    }
    // 入口页会生成 sessionId 并重定向，必须保留访谈前信息收集开关。
    if (preInterviewForm) {
      chikkaParams.set('pre_interview_form', preInterviewForm)
    }
    for (const [key, value] of searchParams.entries()) {
      if (key.startsWith('chikka_ctx_') && key.length > 'chikka_ctx_'.length) {
        chikkaParams.append(key, value)
      }
    }
    const queryString = chikkaParams.toString()
    if (!queryString) {
      return url
    }
    return `${url}${url.includes('?') ? '&' : '?'}${queryString}`
  }

  if (id && params && params.accessId) {
    //凯度招募
    return (
      <Navigate
        to={appendChikkaParams(
          `/interview2/${params.accessId}/${sessionId}/interview?id=${id}&state=${state}`
        )}
        replace
      />
    )
  } else if (!id && params && params.accessId) {
    if (jdParams) {
      //京东招募
      return (
        <Navigate
          to={appendChikkaParams(
            `/interview2/${params.accessId}/${sessionId}/interview?jdParams=${jdParams}`
          )}
          replace
        />
      )
    } else if (chikkaType) {
      return (
        <Navigate
          to={appendChikkaParams(
            `/interview2/${params.accessId}/${sessionId}/interview?chikkaType=${chikkaType}`
          )}
          replace
        />
      )
    } else {
      return (
        <Navigate
          to={appendChikkaParams(
            `/interview2/${params.accessId}/${sessionId}/interview?sourceType=${
              sourceType ? sourceType : ''
            }`
          )}
          replace
        />
      )
    }
  } else {
    return <Navigate to="/interview2/delete" replace />
  }
}
